import { Link } from "react-router-dom";
import { SITE, NAV, waLink } from "@/lib/data";
import { Logo, Eyebrow } from "@/components/Primitives";

export default function Footer() {
    return (
        <footer
            className="bg-pa-ink-900 text-white px-5 sm:px-8 lg:px-16 pt-20 pb-10"
            data-testid="site-footer"
        >
            <div className="mx-auto max-w-[1180px]">
                <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
                    <div>
                        <div className="bg-white inline-flex px-3 py-2 cut-tr-sm">
                            <Logo />
                        </div>
                        <p className="mt-6 font-display text-2xl font-bold max-w-sm leading-snug">
                            {SITE.positioning}
                        </p>
                    </div>

                    <div>
                        <Eyebrow light>Navigate</Eyebrow>
                        <ul className="mt-5 space-y-3">
                            {NAV.map((n) => (
                                <li key={n.to}>
                                    <Link
                                        to={n.to}
                                        className="text-pa-blue-050/70 hover:text-white transition-colors"
                                    >
                                        {n.label}
                                    </Link>
                                </li>
                            ))}
                            <li>
                                <Link
                                    to="/contact"
                                    className="text-pa-blue-050/70 hover:text-white transition-colors"
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <Eyebrow light>Contact</Eyebrow>
                        <ul className="mt-5 space-y-3 text-pa-blue-050/70">
                            <li>
                                <a
                                    href={`mailto:${SITE.email}`}
                                    className="hover:text-white transition-colors"
                                    data-testid="footer-email"
                                >
                                    {SITE.email}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={waLink(
                                        "Hi Phoebus AI — I'd like to discuss AI automation for our business.",
                                    )}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-white transition-colors"
                                >
                                    {SITE.phone}
                                </a>
                            </li>
                            <li className="pt-2 flex gap-4">
                                <a
                                    href={SITE.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-white transition-colors font-mono text-sm"
                                >
                                    LinkedIn
                                </a>
                                <a
                                    href={SITE.facebook}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-white transition-colors font-mono text-sm"
                                >
                                    Facebook
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 grid gap-4 md:grid-cols-2 text-sm text-pa-blue-050/50">
                    <p className="max-w-md">
                        {SITE.entity}
                        <br />
                        {SITE.address}
                    </p>
                    <p className="md:text-right">
                        © {new Date().getFullYear()} {SITE.entity}.
                    </p>
                </div>
            </div>
        </footer>
    );
}
